import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TaskService } from '@components/my-web-desk/new-task-modal/task.service';
import { FullCalendarModule, CalendarOptions, EventInput } from '@fullcalendar/angular';
import { FullCalendarComponent } from '@fullcalendar/angular';
import interactionPlugin from '@fullcalendar/interaction'; // for dateClick
import { Router } from '@angular/router';
import { CalendarService } from '@components/calendar/calendar.service';
import {OdmoriService} from '../odmori.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'kalendar-odsustva',
  templateUrl: './kalendar-odsustva.component.html',
  styleUrls: ['./kalendar-odsustva.component.css']
})

export class KalendarOdsustva implements OnInit {
  constructor(private taskService: TaskService,
    private dialogData: MatDialog,
    private router: Router,
    private calendarService: CalendarService,
    private odmoriService: OdmoriService,
    private toastr: ToastrService) { }

  loader: boolean;
  eventSources: any[] = [];
  count = 0;

  isLoading: boolean;

  calendarOptions: CalendarOptions = {
    headerToolbar: { left: 'dayGridMonth,timeGridWeek', center: 'title', right: 'prev next' },
    initialView: 'dayGridMonth',
    buttonText: {
      today: 'Danas',
      month: 'Mjesec',
      week: 'Nedelja',
      day: 'Dan',
      list: 'Lista'
    },
    locale: 'sr-ME',
    selectable: true,
    height: '88%',
    select: null, 
    eventColor: '#153de7',
    dayMaxEventRows: true,
    eventClick: this.navigatetToRoute.bind(this),
  };

  @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;

  ngOnInit() {
    this.isLoading = true;
    this.getAllHolidayData();
  }


  navigatetToRoute(event) {
    this.router.navigateByUrl('/view-task/' + event.event.id);
  }

  getAllHolidayData() {
      this.odmoriService.getAllHolidayData().subscribe(response => {
        this.isLoading = false;
        
        if (response.type == 'success') {

          const allEvents: EventInput[] = [];
  
          Object.keys(response.data).forEach(key => {
            const eventsArray: EventInput[] = response.data[key].map((event: any) => {
              return {
                title: event.title,
                start: event.start,
                backgroundColor: event.backgroundColor
              };
            });
  
            allEvents.push(...eventsArray);
          });
  
          this.calendarOptions.events = allEvents;

          return;
        }

        this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
    });
  };

}